import React, { useEffect } from 'react';
import Map, { type LngLatLike, type MapRef } from 'react-map-gl';

import { EMap } from '@enums/map.enum';

import 'mapbox-gl/dist/mapbox-gl.css';

export type Region = {
	zoom: number;
	center: Pick<LngLatLike, never> & [number, number];
};

type Props = {
	children?: React.ReactNode;
	region: Region;
	fullScreen?: boolean;
	mapRef?: React.RefObject<MapRef | null>;
};

const MapView: React.FC<Props> = ({ children, region, mapRef }: React.PropsWithChildren<Props>) => {
	useEffect(() => {
		if (region && mapRef?.current) {
			mapRef.current.flyTo({
				center: region.center as LngLatLike,
				zoom: region.zoom,
				duration: 500,
				essential: true,
			});
		}
	}, [region]);

	return (
		<Map
			mapboxAccessToken={import.meta.env.VITE_MAPBOX_GET_ROUTE_TOKEN}
			initialViewState={{
				longitude: region.center[0],
				latitude: region.center[1],
				zoom: region.zoom,
			}}
			ref={mapRef}
			mapStyle={EMap.style}
			style={{ marginTop: 8, height: '100dvh', width: '100%' }}
			attributionControl={false}
			dragPan={true}
			touchZoomRotate={true}
		>
			{children}
		</Map>
	);
};

export default MapView;
